import { FC } from "react";
import { Modal, Loader } from "@mantine/core";

interface IdentityPreviewModalProps {
  opened: boolean;
  onClose: () => void;
  content: string | null;
  type: "image" | "pdf" | null;
  fileName: string;
}

const IdentityPreviewModal: FC<IdentityPreviewModalProps> = ({
  opened,
  onClose,
  content,
  type,
  fileName,
}) => (
  <Modal opened={opened} onClose={onClose} title={fileName} size="xl" centered>
    {!content ? (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "300px",
        }}
      >
        <Loader size="lg" />
      </div>
    ) : (
      <div style={{ width: "100%", minHeight: "400px" }}>
        {type === "image" && (
          <img
            src={content}
            alt={fileName}
            style={{
              maxWidth: "100%",
              maxHeight: "70vh",
              display: "block",
              margin: "0 auto",
            }}
          />
        )}
        {type === "pdf" && (
          <iframe
            src={content}
            title={fileName}
            sandbox=""
            style={{
              width: "100%",
              height: "70vh",
              border: "none",
            }}
          />
        )}
      </div>
    )}
  </Modal>
);

export default IdentityPreviewModal;
